import { render, staticRenderFns } from "./productInfo.vue?vue&type=template&id=2aff04bd&scoped=true&"
import script from "./productInfo.vue?vue&type=script&lang=ts&"
export * from "./productInfo.vue?vue&type=script&lang=ts&"
import style0 from "./productInfo.vue?vue&type=style&index=0&id=2aff04bd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff04bd",
  null
  
)

export default component.exports